// import { Box, Grid2 as Grid, IconButton, Link, Tooltip, Typography } from "@mui/material";
// import { handleUploadFiles } from "../../../../redux/user-slices/chat.slice";
// import { chatSchema } from "../../../../utils/velidations";
// import { checkUserType } from "../../../../utils/helper";
// import { useDispatch, useSelector } from "react-redux";
// import Availability from "../../../ui/availability";
// import InputFieldB from "../../../ui/InputFieldB";
// import { useMemo, useRef, useState } from "react";
// import Icons from "../../../../assets/js/Icons";
// import Preview from "./files/preview";
// import moment from "moment";
// import z from "zod";

// const title = "Kindly do not share any personal information like phone no., address, email address, Etc. Any violation of this might lead to account deactivation."

// function Footer({ availability }) {
//   const files = useRef([]);
//   const input = useRef(null);
//   const container = useRef(null);
//   const dispatch = useDispatch();
//   const [error, setError] = useState("");
//   const [previews, setPreviews] = useState([]);
//   const { socket, chat } = useSelector((state) => state.socketSlice);
//   const { member, specialist } = useSelector((state) => state.authSlice);

//   const handleSubmit = async (e) => {
//     e.preventDefault()
//     const form = new FormData(e.target);
//     const formData = Object.fromEntries(form);
//     let uploadedFiles = null, type = "text"
//     if (files?.current?.length) {
//       type = "file"
//       const { files: data } = await dispatch(handleUploadFiles({
//         files: files.current,
//         receiver: chat?.user?._id,
//       })).unwrap() || {}
//       if (data) uploadedFiles = data
//     }

//     if (!uploadedFiles && !formData?.text?.trim()) return
//     if (uploadedFiles && formData?.text?.trim()) { type = "both" }

//     if (formData?.text?.trim()) {
//       const x = chatSchema.safeParse(formData)
//       if (!x.success) {
//         const { fieldErrors } = z.flattenError(x?.error)
//         return setError(fieldErrors?.text?.at(0))
//       }
//     }
//     setError("")

//     socket.emit("send-message", {
//       type,
//       roomId: chat?._id,
//       text: formData?.text,
//       receiverId: chat?.user?._id,
//       files: uploadedFiles || undefined,
//       sender: (member?._id || specialist?.specialist?._id),
//     });

//     setPreviews([])
//     files.current = null
//     input.current.value = ""
//   }

//   const dayKey = moment().format("dddd").toLowerCase();
//   const todaySchedule = availability?.schedule?.[dayKey];

//   const isCurrentlyAvailable = useMemo(() => {
//     if (!availability?.timeZone || !todaySchedule) return false;

//     // Best: Check in the specialist's own timezone (simplest and most accurate)
//     const nowInSpecialistTz = moment().tz(availability?.timeZone);
//     const currentTime = nowInSpecialistTz.format("HH:mm");

//     return (
//       currentTime >= todaySchedule?.startTime &&
//       currentTime <= todaySchedule?.endTime
//     );
//     // eslint-disable-next-line
//   }, [availability]);

//   // const currentlyAvailable = isCurrentlyAvailable();
//   return (
//     (isCurrentlyAvailable || checkUserType() === "specialist") ?
//       <Box position="relative">
//         <Grid
//           ref={container}
//           container p={1}
//           component="form"
//           alignItems="center"
//           onSubmit={handleSubmit}
//           columnSpacing={1}
//         >
//           <Grid size="auto">
//             <Preview
//               files={files}
//               previews={previews}
//               setPreviews={setPreviews}
//             />
//           </Grid>
//           <Grid size="grow" sx={{ ".MuiInputBase-root": { borderRadius: "30px" } }}>
//             <Tooltip
//               title={error}
//               open={Boolean(error)}
//               placement="top-start"
//               slotProps={{
//                 tooltip: {
//                   sx: {
//                     fontSize: 12.75,
//                     color: "red.400",
//                     border: "1px solid",
//                     borderColor: "red.200",
//                     backgroundColor: "red.50",
//                     maxWidth: { xs: 500, xl: (container?.current?.clientWidth || 0) },
//                   }
//                 }
//               }}
//             >
//               <InputFieldB
//                 hiddenLabel
//                 name="text"
//                 inputRef={input}
//                 variant="filled"
//                 labelvariant="InputLabelA"
//                 placeholder="Write message here.."
//                 slotProps={{
//                   input: {
//                     startAdornment:
//                       <Tooltip
//                         title={title}
//                         placement="top-start"
//                         slotProps={{
//                           tooltip: {
//                             sx: {
//                               fontSize: 12.75,
//                               color: "red.400",
//                               border: "1px solid",
//                               borderColor: "red.200",
//                               backgroundColor: "red.50",
//                               maxWidth: { xs: 500, xl: (container?.current?.clientWidth || 0) },
//                             }
//                           }
//                         }}
//                       >
//                         <IconButton
//                           sx={{
//                             fontSize: 16,
//                             bgcolor: "red.300",
//                             ":hover": { bgcolor: "red.400", },
//                             mr: 0.5,
//                             color: "white",
//                             p: 0.25,
//                             svg: { display: "block" }
//                           }}
//                         >
//                           <Icons.Alert />
//                         </IconButton>
//                       </Tooltip>
//                   }
//                 }}
//               />
//             </Tooltip>
//           </Grid>
//           <Grid size="auto">
//             <IconButton
//               size="small"
//               type="submit"
//               sx={{ "svg": { fontSize: 22 } }}
//             ><Icons.SentPlane />
//             </IconButton>
//           </Grid>
//         </Grid>
//       </Box> :
//       <Typography p={1} variant="body2" textAlign="center" fontSize={13}>
//         The specialist you're trying to message is not available right now. You can check their availability <Availability
//           availability={availability}
//           trigger={<Link sx={{ display: "inline-block" }} component="span">here</Link>}
//         />. Feel free to try again later!
//       </Typography>
//   )
// }

// export default Footer

import {
  Box,
  Button,
  Grid2 as Grid,
  IconButton,
  Link,
  Tooltip,
  Typography
} from "@mui/material";

import { handleUploadFiles } from "../../../../redux/user-slices/chat.slice";
import { chatSchema } from "../../../../utils/velidations";
import { checkUserType } from "../../../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import Availability from "../../../ui/availability";
import InputFieldB from "../../../ui/InputFieldB";
import { useMemo, useRef, useState } from "react";
import Icons from "../../../../assets/js/Icons";
import Preview from "./files/preview";
import moment from "moment-timezone";
import z from "zod";

import { playSendMessageSound } from "../../../../utils/sound.utils";
import { showDialog, showDialogWithData } from "../../../../redux/guest-slices/other.slice";
import { APPOINTMENT_SLOTS, FEATURE_GUARD, GUEST_LOGIN } from "../../../../utils/keywords";

const title =
  "Kindly do not share any personal information like phone no., address, email address, Etc. Any violation of this might lead to account deactivation.";

function Footer({ availability, chatLimitMessage, chatUsage }) {
  const files = useRef([]);
  const input = useRef(null);
  const container = useRef(null);

  const dispatch = useDispatch();

  const [error, setError] = useState("");
  const [previews, setPreviews] = useState([]);

  const { socket, chat } = useSelector((state) => state.socketSlice);
  const { member, specialist } = useSelector((state) => state.authSlice);
  const { features } = useSelector((state) => state.subscriptionSlice);

  const isChatBlocked = Boolean(chatLimitMessage);
  const hasAccess = features?.includes("APPOINTMENT_UNLIMITED");

  const targetSpecialistId = useMemo(() => {
    return (
      chat?.user?._id ||
      chat?.otherUserId ||
      (chat?.participants?.find(
        (p) => (p?._id || p).toString() !== member?._id?.toString()
      )?._id ||
        chat?.participants?.find(
          (p) => (p?._id || p).toString() !== member?._id?.toString()
        ))?.toString()
    );
  }, [chat, member]);

  const handleBookAppointment = () => {
    if (!hasAccess) {
      dispatch(
        showDialog(FEATURE_GUARD, {
          title: "Appointment Booking Locked",
          description:
            "Upgrade to Premium or Platinum to book appointments with specialists.",
          requiredPlan: "Premium",
        })
      );
      return;
    }

    if (checkUserType() !== "member") {
      dispatch(showDialog(GUEST_LOGIN));
      return;
    }

    if (targetSpecialistId) {
      dispatch(
        showDialogWithData({
          type: APPOINTMENT_SLOTS,
          data: {
            specialistId: targetSpecialistId,
          },
        })
      );
    }
  };


  // ---------------- submit ----------------
  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = new FormData(e.target);
    const formData = Object.fromEntries(form);

    let uploadedFiles = null;
    let type = "text";

    if (files?.current?.length) {
      type = "file";

      const { files: data } =
        (await dispatch(
          handleUploadFiles({
            files: files.current,
            receiver: chat?.user?._id
          })
        ).unwrap()) || {};

      if (data) uploadedFiles = data;
    }

    if (!uploadedFiles && !formData?.text?.trim()) return;

    if (uploadedFiles && formData?.text?.trim()) {
      type = "both";
    }

    if (formData?.text?.trim()) {
      const x = chatSchema.safeParse(formData);
      if (!x.success) {
        const { fieldErrors } = z.flattenError(x?.error);
        return setError(fieldErrors?.text?.at(0));
      }
    }

    setError("");

    playSendMessageSound();

    socket.emit("send-message", {
      type,
      roomId: chat?._id,
      text: formData?.text,
      receiverId: chat?.user?._id,
      files: uploadedFiles || undefined,
      sender: member?._id || specialist?.specialist?._id || specialist?._id
    });

    setPreviews([]);
    files.current = null;
    input.current.value = "";
  };

  // ---------------- availability ----------------
  const dayKey = moment().format("dddd").toLowerCase();
  const todaySchedule = availability?.schedule?.[dayKey];

  const isCurrentlyAvailable = useMemo(() => {
    if (!availability?.timeZone || !todaySchedule) return false;

    const nowInTz = moment().tz(availability.timeZone);
    const currentTime = nowInTz.format("HH:mm");

    return (
      currentTime >= todaySchedule.startTime &&
      currentTime <= todaySchedule.endTime
    );
  }, [availability, todaySchedule]);

  // ---------------- 1. CHAT BLOCKED ----------------
  if (isChatBlocked) {
    const isSpecialist = checkUserType() === "specialist";
    let displayMessage = chatLimitMessage;

    if (isSpecialist && chatLimitMessage) {
      if (chatLimitMessage.includes("messages per day across all specialists")) {
        displayMessage = "The member has reached their daily message limit.";
      } else if (chatLimitMessage.includes("messages per month across all specialists")) {
        displayMessage = "The member has reached their monthly message limit.";
      } else if (chatLimitMessage.includes("3 unique specialists per month")) {
        displayMessage = "The member has reached their limit of unique specialists this month.";
      } else if (chatLimitMessage.includes("Free members cannot initiate")) {
        displayMessage = "Free members cannot initiate or send chat messages without an appointment.";
      } else if (chatLimitMessage.includes("monthly chat limit")) {
        displayMessage = "The member has reached their monthly chat limit.";
      } else if (chatLimitMessage.includes("does not include chat access")) {
        displayMessage = "The member's subscription does not include chat access.";
      } else {
        displayMessage = chatLimitMessage
          .replace(/You have/i, "The member has")
          .replace(/Your/i, "The member's")
          .replace(/you're/i, "the member is")
          .replace(/you/i, "the member")
          .replace(/members can/i, "member can")
          .replace(/across all specialists/i, "");
      }
    }

    return (
      <Box p={2} display="flex" flexDirection="column" alignItems="center">
        <Typography textAlign="center" color="error" fontWeight={600}>
          {displayMessage}
        </Typography>

        <Typography textAlign="center" variant="body2" sx={{ mt: 1 }}>
          {isSpecialist ? "The member has used" : "You have used"}{" "}
          {chatUsage.chatMessagesUsed}/{chatUsage.totalChatMessages} messages this month.
        </Typography>

        {!isSpecialist && (
          <Button
            variant="contained"
            color="secondary"
            startIcon={<Icons.Appointment />}
            onClick={handleBookAppointment}
            sx={{ borderRadius: "30px", px: 2.5, py: 1, mt: 1.5, color: "white", fontWeight: 600 }}
          >
            Book Appointment
          </Button>
        )}
      </Box>
    );
  }

  console.log({ isCurrentlyAvailable });

  // ---------------- 2. OFFLINE STATE ----------------
  if (!(isCurrentlyAvailable || checkUserType() === "specialist")) {
    return (
      <Typography
        p={1}
        variant="body2"
        textAlign="center"
        fontSize={13}
      >
        The specialist you're trying to message is not available right now.
        You can check their availability{" "}
        <Availability
          availability={availability}
          trigger={
            <Link sx={{ display: "inline-block" }} component="span">
              here
            </Link>
          }
        />{" "}
        . Feel free to try again later!
      </Typography>
    );
  }

  // ---------------- 3. ACTIVE FOOTER ----------------
  return (
    <Box position="relative">
      <Grid
        ref={container}
        container
        p={1}
        component="form"
        alignItems="center"
        onSubmit={handleSubmit}
        columnSpacing={1}
      >
        {/* Preview */}
        <Grid size="auto">
          <Preview
            files={files}
            previews={previews}
            setPreviews={setPreviews}
          />
        </Grid>

        {/* Input */}
        <Grid
          size="grow"
          sx={{ ".MuiInputBase-root": { borderRadius: "30px" } }}
        >
          <Tooltip
            title={error}
            open={Boolean(error)}
            placement="top-start"
          >
            <InputFieldB
              hiddenLabel
              name="text"
              inputRef={input}
              variant="filled"
              placeholder="Write message here.."
              slotProps={{
                input: {
                  startAdornment: (
                    <Tooltip title={title} placement="top-start">
                      <IconButton
                        sx={{
                          fontSize: 16,
                          bgcolor: "red.300",
                          ":hover": { bgcolor: "red.400" },
                          mr: 0.5,
                          color: "white",
                          p: 0.25
                        }}
                      >
                        <Icons.Alert />
                      </IconButton>
                    </Tooltip>
                  )
                }
              }}
            />
          </Tooltip>
        </Grid>

        {/* Send button */}
        <Grid size="auto">
          <IconButton size="small" type="submit">
            <Icons.SentPlane />
          </IconButton>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Footer;